import {createFeatureSelector, createSelector} from '@ngrx/store';
import {IPhrasesEntityState, phrasesFeatureKey, selectAll} from '../_reducers/phrases.reducer';
import {JournalEditMode} from '../_interface/journal-edit-mode.enum';
import {DocumentationPhraseDto} from 'app/_models/model/documentationPhraseDto';
import * as fromTemplateFields from '../_selectors/template-field-entity.selectors';
import {templateFieldById} from '../_reducers/templateFieldById.fn';
import {IPhrase} from '../_interface/phrases.model';

export const phrasesEntityState = createFeatureSelector<IPhrasesEntityState>(phrasesFeatureKey);
export const selectAllPhrases = createSelector(phrasesEntityState, selectAll);
export const selectPhrasesForTemplateField = (tfid: string) => createSelector(selectAllPhrases,
	(phrases) => phrases.filter(({templateFieldId}) => templateFieldId === tfid));
export const selectOne = (phraseId: string) => createSelector(phrasesEntityState,
	(entities) => {
		return entities.entities[phraseId];
	});

export const selectEditPhrase = createSelector(phrasesEntityState, ({editPhrase}) => editPhrase);
export const selectEditPhraseAndMode = createSelector(phrasesEntityState,
	({mode, editPhrase}): { mode: JournalEditMode, editPhrase: DocumentationPhraseDto } => ({mode, editPhrase}));

export const selectEditPhraseFullAndMode = createSelector(phrasesEntityState, fromTemplateFields.selectAll,
	({mode, editPhrase}, templateFields): { mode: JournalEditMode, editPhrase: IPhrase } => {
		if (!editPhrase) return null;
		const {fieldType} = templateFieldById(editPhrase.templateFieldId, templateFields);
		return {
			mode,
			editPhrase: {...editPhrase, type: fieldType}
		};
	});
export const selectPhraseIdToDelete = createSelector(phrasesEntityState, state => state.phraseIdToDelete);
